import { SxProps, Theme } from '@mui/material'
import { forwardRef, KeyboardEvent } from 'react'

import { FormControl, FormControlWrapper } from '../form/form-control'
import { InputBase } from '../input-base'

export type TextFieldProps = FormControlWrapper & {
  value: string
  onChange: (value: string) => void
  onKeyPress?: (event: KeyboardEvent<HTMLInputElement>) => void

  type?: string
  placeholder?: string
  autoComplete?: string

  startAdornment?: React.ReactNode
  endAdornment?: React.ReactNode

  whiteLilacBackground?: boolean
  rounded?: boolean
  small?: boolean
  disabled?: boolean
  autoFocus?: boolean

  multiline?: boolean
  resizable?: boolean
  rows?: number
  maxRows?: number
  minRows?: number
  sx?: SxProps<Theme>
}

export const TextField = forwardRef<HTMLInputElement, TextFieldProps>(
  (
    { label, error, helperText, onChange, id, onRemove, required, sx, ...rest },
    ref,
  ) => {
    return (
      <FormControl
        label={label}
        error={error}
        helperText={helperText}
        id={id}
        onRemove={onRemove}
        required={required}
      >
        <InputBase
          ref={ref}
          id={id ?? label}
          onChange={event => onChange(event.target.value)}
          error={error}
          required={required}
          {...(sx && {
            sx,
          })}
          {...rest}
        />
      </FormControl>
    )
  },
)
